import { NgClass, NgFor, NgIf } from '@angular/common';
import { Component, Input, OnInit, SimpleChange, ViewEncapsulation } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FileManagerComponent } from 'app/modules/admin/apps/file-manager/file-manager.component';
import { labelColorDefs, labelColors } from 'app/shared/global-constants';
import { FileManagerService } from 'app/modules/admin/apps/file-manager/file-manager.service';
import { fuseAnimations } from '@fuse/animations';
import { LabelService } from 'app/services/label.service';
import { ToastrService } from 'ngx-toastr';
import { Label } from 'app/models/label';
import { Util } from 'app/models/util';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { MatTooltipModule } from '@angular/material/tooltip';
import {CdkDragDrop, CdkDropList, CdkDrag, moveItemInArray} from '@angular/cdk/drag-drop';
import { NgxLoadingModule } from 'ngx-loading';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'settings-labels',
    templateUrl: './labels.component.html',
    styleUrls: ['./labels.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    standalone: true,
    imports: [
        MatButtonModule,
        MatIconModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        NgClass,
        NgFor,
        MatOptionModule,
        NgIf,
        MatTooltipModule,
        CdkDropList, CdkDrag,
        NgxLoadingModule,
    ],
    providers : [FileManagerComponent]
})
export class LabelsComponent implements OnInit {
    @Input() defaultView: string = null;
    labelColors: any = labelColors;
    labelColorDefs: any = labelColorDefs;
    focusedLableIndex: number = null;

    labels: Label[];
    labelsForm: UntypedFormGroup;
    labelId = null;
    initialValues: { [key: number]: Label } = {};
    
    deleteLabelForm: UntypedFormGroup;
    isLoading:boolean=false

    /**
     * Constructor
     */
    constructor(
        public _fileManagerComponent: FileManagerComponent,
        private _formBuilder: UntypedFormBuilder,
        private _fileManagerService: FileManagerService,
        private _fuseConfirmationService: FuseConfirmationService,
        private labelService: LabelService,
        private toastr: ToastrService,
        private titleService: Title
    ) {
        this.titleService.setTitle("DMS - Labels");
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
		for (let propName in changes) {
			let changedProp = changes[propName];
			let to = changedProp.currentValue; //JSON.stringify();
			if (changedProp.isFirstChange()) {
			} else {
				let from = JSON.stringify(changedProp.previousValue);
				if (`${propName}` == `defaultView`) {
					this.defaultView = to;
                    console.log(this.defaultView, "defaultView======= Labels====")
					
				}
			}
		}
	}

    /**
     * On init
     */
    ngOnInit(): void {
        // Create the labels form
        this.labelsForm = this._formBuilder.group({
            labels: this._formBuilder.array([]),
            newLabel: this._formBuilder.group({
                name: ['', Validators.required],
                color: ['orange'],
            }),
        });

        this.deleteLabelForm = this._formBuilder.group(
            Util.deleteLabelForm
         );

        this.getLabels();
    }

    trackByFn(index: number): any {
        return index;
    }

    /**
     * Retrieves the labels from the label service and populates the labels form array.
     */
    getLabels() {
        this.labelService.getLabels().then((res) => {
            this.labels = this.labelService.getData(res);
            (this.labelsForm.get('labels') as UntypedFormArray).clear()
            if (this.labels && this.labels.length > 0) {
                this.labels.forEach((label) => {
                    // Create a label form group
                    const labelFormGroup = this._formBuilder.group({
                        id: [label.id],
                        name: [label.name, Validators.required],
                        color: [label.color],
                        sequence:[label.sequence]
                    });

                    const initialValue = label.name;
                    this.initialValues[label.id] = initialValue;

                    // Add the label form group to the labels form array
                    (this.labelsForm.get('labels') as UntypedFormArray).push(labelFormGroup);

                })
            }

        }).catch((error) => {
            console.log(error);
        })
    }

    /**
     * Saves a label. If the label is new, it will be added to the database. 
     * 
     * @param label - The label to be saved.
     */
    saveLabel(label: Label) {
        // Implement save logic here
        this.labelService.saveLabel(label).then((res) => {
            this.labels = this.labelService.getData(res);

            this.toastr.info("Label applied");

            (this.labelsForm.get('labels') as UntypedFormArray).push(this._formBuilder.group({
                id: [null],
                name: [label.name, Validators.required],
                color: [label.color],
                sequence:[label.sequence]
            }));
        }).catch((error) => {
            console.log(error);
        })
    }

    /**
     * Deletes a record with the specified ID.
     * @param {number} id - The ID of the record to delete.
     */
    delete(id) {
        this.labelService.deleteRecord(id).then((res) => {
            this.toastr.warning("Label removed");
        }).catch((error) => {
            console.log(error);
        })
    }

    changeColor(label, index){

    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Adds a label to the server and updates the labels form.
     */
    addLabel(): void {
        // Add label to the server
        let addedLabel = this.labelsForm.get('newLabel').value;
        let label: Label = new Label();
        label.name = addedLabel.name;
        label.color = addedLabel.color;
        //label.created_by = 'b0f2d311-df7f-42b6-bcbe-19f489d89c95';
        // Push the new label to the labels form array

        this.saveLabel(label);

        // Reset the new label form
        this.labelsForm.get('newLabel').markAsPristine();
        this.labelsForm.get('newLabel').markAsUntouched();
        this.labelsForm.get('newLabel.name').reset();
        this.labelsForm.get('newLabel.name').clearValidators();
        this.labelsForm.get('newLabel.name').updateValueAndValidity();
    }

    /**
     * Deletes a label.
     * 
     * @param id - The ID of the label to be deleted.
     * @param index - The index of the label in the labels form array.
     */
    deleteLabel(id, index): void {
        //TODO - check permissions for delete labels

        //confirmation prompt
        const dialogRef = this._fuseConfirmationService.open(this.deleteLabelForm.value);

        // Subscribe to afterClosed from the dialog reference
        dialogRef.afterClosed().subscribe((result) => {
            if (result === 'confirmed') {
                 // Remove the label from the labels form array
                const labelsFormArray = this.labelsForm.get('labels') as UntypedFormArray;
                labelsFormArray.removeAt(index);
                this.delete(id);
            }
        });
    }

    /**
     * Updates a label and displays a success message.
     * @param {any} label - The label to be updated.
     * @param {number} index - The index of the label in the array.
     */
    updateLabelText(label) {
        if (label){
            const initialValue = this.initialValues[label.id];
            if (label.name !== initialValue) {
                console.log('Value changed, saving:', label.name);
                this.labelService.updateLabel(label).then((res) => {
                     // Update the initial value in cache to the new value after saving
                     this.initialValues[label.id] = label.name;
                    this.toastr.success('Label updated');
        
                }).catch((error) => {
                    console.log(error);
                })
            }
        }
    }

    /**
     * Updates a label and displays a success message.
     * @param {any} label - The label to be updated.
     * @param {number} index - The index of the label in the array.
     */
    updateLabel(label) {
        this.labelService.updateLabel(label).then((res) => {
            // Update the initial value in cache to the new value after saving
            this.initialValues[label.id] = label.name;
            this.toastr.success('Label updated');
        }).catch((error) => {
            console.log(error);
        })
    }

    /**
     * Handles the blur event of the input element.
     * Calls the updateLabels function to save the value.
     * 
     * @param event - The blur event object.
     * @param value - The value of the input element.
     * @param index - The index of the input element.
     */
    onBlur(event: any, value: any, index: number): void {
        this.updateLabelText(value); // Call save function on blur
    }

    drop(event: CdkDragDrop<any[]>) {
        const NewSequence:number=event.currentIndex
        const Labelid:string=event.item.data

        this.isLoading=true
        
        this.labelService.updateSequence(Labelid,NewSequence).then(res=>{
            moveItemInArray(this.labelsForm.get('labels')['controls'],event.previousIndex, event.currentIndex);
            this.getLabels()
            this.isLoading=false
        }).catch(error=>{
            console.log(error)
            this.isLoading=false
        })
      }
}
